import script from "./CorporateCulture.vue?vue&type=script&lang=ts&setup=true"
export * from "./CorporateCulture.vue?vue&type=script&lang=ts&setup=true"

import "./CorporateCulture.vue?vue&type=style&index=0&id=065d6e9f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-065d6e9f"]])

export default __exports__